module.exports = __webpack_public_path__ + "static/media/zeya_drawing_06.e6c91a9d.png";